import { useTranslation } from "@/i18n"
import type { NostrEvent } from "@/nostr/types"
import { Modal } from "./Modal"
import { NoteCard } from "./NoteCard"
import { Composer } from "./Composer"

export interface ReplyDialogProps {
  open: boolean
  onClose: () => void
  replyTo: NostrEvent
  root?: NostrEvent
  onReplied?: () => void
}

/** Reply composer dialog, opened from the reply action of any note. */
export function ReplyDialog({ open, onClose, replyTo, root, onReplied }: ReplyDialogProps) {
  const { t } = useTranslation()

  return (
    <Modal open={open} onClose={onClose} title={t("Reply to")} size="medium">
      <div className="reply-dialog">
        <NoteCard event={replyTo} static showActions={false} className="reply-dialog-target" />
        <Composer
          replyTo={replyTo}
          root={root ?? replyTo}
          autoFocus
          onPublished={() => {
            onReplied?.()
            onClose()
          }}
        />
      </div>
    </Modal>
  )
}
